import moment from 'moment';
import { getUserRolesInCurrentlySelectedSite } from '../services/auth';
import { getChatRoles, getChatTitles } from '../helpers/chat';

export const chatConversationModel = (user) => ({
  custom: {
    createdBy: String(user.id),
    resolved: 'false',
    staffMembersAdded: 'false',
  },
});

export const chatCurrentUserModel = ({ user, picture, isSiteStaff = false }) => {
  const userRolesInActiveSite = getUserRolesInCurrentlySelectedSite(user);
  const userRoleNamesInActiveSite = (userRolesInActiveSite || []).map((role) => role.role_name);
  const userChatRoles = getChatRoles(userRoleNamesInActiveSite, isSiteStaff);
  const userChatTitles = getChatTitles(userRolesInActiveSite);

  return {
    name: user.firstname,
    photoUrl: picture,
    custom: {
      roles: userChatRoles.length > 0 ? JSON.stringify(userChatRoles) : null,
      titles: !isSiteStaff && userChatTitles.length > 0 ? JSON.stringify(userChatTitles) : null,
      fullname: `${user?.firstname} ${user.lastname}`,
      email: user.email,
    },
  };
};

export const chatSiteStaffModel = (member) => {
  const memberChatRoles = getChatRoles(member?.roles, true);

  return {
    name: member.firstname,
    custom: {
      roles: memberChatRoles.length > 0 ? JSON.stringify(memberChatRoles) : null,
      fullname: member.name,
      email: member.email,
    },
  };
};

export const chatResolvedModel = (user) => ({
  custom: {
    resolved: 'true',
    resolvedAt: String(moment().valueOf()),
    resolvedBy: user.firstname,
    resolvedById: String(user.id),
  },
});

export const chatReopenModel = (user) => ({
  custom: {
    resolved: 'false',
    reopenAt: String(moment().valueOf()),
    reopendBy: user.firstname,
    reopendById: String(user.id),
  },
});
